import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

const SwitchComponent = ({value, handleChange, labelValue, disableSwitch = false}) => {
    return(
        <div>
            <FormControlLabel 
                label= {labelValue}
                labelPlacement="start"
                control={
                <Switch
                    checked={value}
                    onChange={handleChange}
                    disabled={disableSwitch}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{
                    // Set the color of the switch base (unchecked state)
                    '& .MuiSwitch-switchBase': {
                        color: '#808080', // Change to a valid RGB color format
                    },
                    // Set the color when the switch is checked
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: 'rgb(0, 103, 161)', // Same color for checked state
                    },
                    // Set the background color of the track when the switch is checked
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: 'rgb(0, 103, 161)', // Blue color for the track when checked
                    },
                    marginRight: '15px',
                    }}
                />
                }   
                sx={{
                    // Change the label color to light grey
                    '& .MuiFormControlLabel-label': {
                        color: '#0000008a', // Apply light grey color to the label text
                    }
                }}
            />
        </div>
    );
};

export default SwitchComponent;